import Avatar from './Avatar'
export { transformData } from './fragment'

export default Avatar
